import React, { useState, useEffect } from 'react';
import { Layout, Spin } from 'antd';
import Sidebar from '../Sidebar/Sidebar';
import CustomFooter from '../../Footer/Footer';
import DashboardHeader from '../Header/DashboardHeader';
import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { antIcon } from '../../Helpers/helpers';

const { Header, Sider, Content } = Layout;

const AppLayout = ({ children, sidebarKey, home }) => {

  const { mainLoader } = useSelector(state => state.utils.loaders);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (true) {
      window.fwSettings = {
        widget_id: 62000000625,
      };
      if (typeof window.FreshworksWidget !== 'function') {
        const n = function () {
          n.q.push(arguments);
        };
        n.q = [];
        window.FreshworksWidget = n;
      }
      loadScript('https://widget.freshworks.com/widgets/62000000625.js');
    }
  }, []);

  function loadScript(url) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  return (
    <Spin indicator={antIcon} spinning={mainLoader}>
      <div className="main-wrapper">
        <Layout>
            <Header className='headerMain' style={{ width: '100%' }}><DashboardHeader home={home} collapsed={{ state: collapsed, setState: setCollapsed }} /></Header>
          <Sider className='sidebarMain' trigger={null} collapsible collapsed={collapsed}><Sidebar sideKey={sidebarKey} collapsed={{ state: collapsed, setState: setCollapsed }} /></Sider>
          <Layout>
            <Content className='content' style={{ backgroundColor: "white" }}>
              {children}
            </Content>
            <CustomFooter />
          </Layout>
        </Layout>
      </div>
    </Spin>
  );
}

export default AppLayout;
